export default "__VITE_ASSET__CTYn6qU___"